// extracted by mini-css-extract-plugin
module.exports =  {"labelWithIcon":"labelWithIcon__vqt0b"};